import React from 'react';

// RefundPolicy component written in TypeScript
const RefundPolicy: React.FC = () => {
  return (
    <div className="container mx-auto my-16 p-8">
      <h1 className="text-4xl font-bold mb-8">Refund Policy for GDSC VNRVJIET</h1>

      <p className="mb-4">
        Thank you for choosing GDSC VNRVJIET for your learning and development needs. We strive to ensure the best possible experience for our participants. However, we understand that sometimes plans change, and you may need to cancel your registration for our events or workshops. Please read our refund policy carefully to understand your rights and obligations.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-4">Cancellations and Refunds</h2>
      <p className="mb-4">
        If you need to cancel your registration for an event or workshop, please contact us as soon as possible. Refund eligibility is determined based on the date of cancellation and the type of event.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-4">Refund Eligibility</h2>
      <p className="mb-4">
        Refund eligibility is specific to the particular event, will be updated in the event's page.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-4">Event Cancellations by GDSC VNRVJIET</h2>
      <p className="mb-4">
        In the unlikely event that we need to cancel an event or workshop, you will receive a full refund of the registration fee. We will notify you of the cancellation via email as soon as possible.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-4">Refund Process</h2>
      <p className="mb-4">
        To request a refund, please contact us through our contact us page. Include your registration details and the reason for the cancellation. Refunds will be processed within 7-10 business days after receiving your request. The refund will be issued to the original payment method used during registration.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-4">Non-Refundable Fees</h2>
      <p className="mb-4">
        Certain fees are non-refundable, including but not limited to processing fees, service charges, and any other non-registration fees incurred during the registration process.
      </p>

      <h2 className="text-2xl font-bold mt-8 mb-4">Contact Us</h2>
      <p className="mb-4">
        If you have any questions or concerns about our refund policy, please contact us. We are here to help and ensure your experience with GDSC VNRVJIET is positive.
      </p>

      <p className="mb-4">
        By registering for our events or workshops, you acknowledge that you have read, understood, and agree to the terms of this refund policy.
      </p>
    </div>
  );
};

export default RefundPolicy;
